enum Serving {
  single_serve = 'single_serve',
  standard_serving = 'standard_serving'
}

export { Serving }
